// extracted by mini-css-extract-plugin
module.exports = {"chart":"BarChart_chart__2uhfD","title":"BarChart_title__1XFU_ text-md"};